import React from 'react';

export default function Purpose({ onBack }) {
  return (
    <div style={{
      fontFamily: "'Montserrat', sans-serif",
      /* Deep radial gradient for the 'Void' look */
      background: 'radial-gradient(circle at 50% 0%, #1a2a40 0%, #0a1628 80%)',
      minHeight: '100vh',
      color: '#fff',
      position: 'relative',
      minHeight: '-webkit-fill-available',
      overflowX: 'hidden',
    }}>
      
      {/* Sticky Navigation Header with Gradient Mask */}
      <div style={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        paddingTop: 'calc(10px + env(safe-area-inset-top))',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingBottom: '10px',
        background: 'linear-gradient(180deg, rgba(10,22,40,0.85) 0%, rgba(10,22,40,0) 100%)',
        pointerEvents: 'none' 
      }}>
        {/* Back Button - Bubble Pill */}
        <button 
          onClick={onBack}
          className="ios-button"
          style={{
            pointerEvents: 'auto',
            appearance: 'none',
            background: 'rgba(255, 255, 255, 0.08)',
            border: '1px solid rgba(255, 255, 255, 0.15)',
            borderRadius: '30px',
            color: '#e6c57e',
            fontFamily: "'Montserrat', sans-serif",
            fontSize: '0.9rem',
            fontWeight: 600,
            letterSpacing: '0.05em',
            padding: '10px 20px 10px 16px',
            cursor: 'pointer',
            backdropFilter: 'blur(20px)',
            WebkitBackdropFilter: 'blur(20px)',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
            WebkitTapHighlightColor: 'transparent',
            transition: 'all 0.2s cubic-bezier(0.25, 0.1, 0.25, 1)',
          }}
        >
          <span style={{ fontSize: '1.2rem', lineHeight: 0, marginBottom: '2px' }}>←</span> Back
        </button>
      </div>

      {/* Main Content */}
      <div style={{
        maxWidth: '600px',
        margin: '0 auto',
        padding: '10px 20px 120px',
        paddingBottom: 'calc(120px + env(safe-area-inset-bottom))',
        boxSizing: 'border-box'
      }}>
        
        <h1 style={{
          fontFamily: "'Bodoni Moda', serif",
          fontSize: 'clamp(2.5rem, 8vw, 4rem)',
          background: 'linear-gradient(180deg, #e6c57e 20%, #bf953f 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          letterSpacing: '-0.02em',
          fontWeight: 400,
          marginBottom: '40px',
          textAlign: 'center',
          lineHeight: 1.1,
          filter: 'drop-shadow(0px 4px 12px rgba(198,162,91,0.3))'
        }}>
          Why This Matters
        </h1>

        {/* Opening Statement - Glass Card */}
        <div className="glass-card" style={{ 
          padding: '24px', 
          borderLeft: '4px solid #e6c57e',
          background: 'linear-gradient(90deg, rgba(198,162,91,0.1) 0%, rgba(255,255,255,0.03) 100%)'
        }}>
          <p style={{
            fontFamily: "'Montserrat', sans-serif",
            fontSize: '1.1rem',
            lineHeight: 1.7,
            color: '#f5f5f0',
            fontWeight: 400,
            margin: 0
          }}>
            The average person takes 15-20 photos before choosing one to post. 
            They delete posts that don't get enough likes. They calculate everything. 
            <span style={{ fontWeight: 600, color: '#e6c57e' }}> drfts is the opposite.</span>
          </p>
        </div>

        {/* Stats Section - Bento Grid Layout */}
        <div style={{ marginTop: '50px', marginBottom: '50px' }}>
          <h2 className="section-header" style={{ textAlign: 'left', marginLeft: '10px' }}>
            The Problem
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)', // 2 Column Grid for mobile
            gap: '16px',
          }}>
            {[
              {
                stat: "64%",
                text: "of users delete posts that don't get enough likes within the first hour",
                span: 2 // Full width
              },
              {
                stat: "12 min",
                text: "average time spent crafting a single Instagram caption",
                span: 1
              },
              {
                stat: "3 min",
                text: "before unlocking phone to check for likes",
                span: 1
              },
              {
                stat: "62%",
                text: "skipped posting because they feared low engagement",
                span: 2 // Full width
              }
            ].map((item, i) => (
              <div key={i} className="glass-card" style={{
                gridColumn: `span ${item.span}`,
                marginBottom: 0, // Reset default margin for grid
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                background: 'rgba(255, 255, 255, 0.04)',
                textAlign: item.span === 1 ? 'center' : 'left'
              }}>
                <div style={{
                  fontFamily: "'Bodoni Moda', serif",
                  fontSize: item.span === 1 ? '2rem' : '3rem',
                  background: 'linear-gradient(135deg, #e6c57e 0%, #fff 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  marginBottom: '8px',
                  fontWeight: 400,
                  lineHeight: 1
                }}>
                  {item.stat}
                </div>
                <div style={{
                  fontFamily: "'Montserrat', sans-serif",
                  fontSize: '0.85rem',
                  lineHeight: 1.5,
                  color: '#d4d4d0',
                  fontWeight: 400,
                  opacity: 0.9
                }}>
                  {item.text}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* The Solution - Inset Grouped List */}
        <div style={{ marginBottom: '60px' }}>
          <h2 className="section-header" style={{ textAlign: 'left', marginLeft: '10px' }}>
            What drfts Does Differently
          </h2>

          <div className="glass-card" style={{ padding: 0 }}>
            {[
              {
                title: "No Metrics",
                desc: "No follower counts. No likes. No view counts. Share without the scoreboard."
              },
              {
                title: "No Algorithm",
                desc: "See posts in chronological order. No engagement optimization. No content manipulation."
              },
              {
                title: "100% Human",
                desc: "Real people sharing real moments. No AI-generated content. No curated personas."
              }
            ].map((item, i, arr) => (
              <div key={i} style={{
                padding: '24px 20px',
                borderBottom: i !== arr.length - 1 ? '1px solid rgba(255,255,255,0.08)' : 'none',
                display: 'flex',
                flexDirection: 'column',
                gap: '8px'
              }}>
                <h3 style={{
                  fontFamily: "'Montserrat', sans-serif",
                  fontSize: '1.1rem',
                  color: '#e6c57e',
                  fontWeight: 600,
                  margin: 0,
                  letterSpacing: '0.02em',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px'
                }}>
                  {/* Simple decorative dot */}
                  <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#e6c57e' }}></span>
                  {item.title}
                </h3>
                <p style={{
                  fontFamily: "'Montserrat', sans-serif",
                  fontSize: '0.95rem',
                  lineHeight: 1.6,
                  color: 'rgba(255,255,255,0.8)',
                  fontWeight: 300,
                  margin: 0,
                  paddingLeft: '16px' // Align text with title
                }}>
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Closing Statement */}
        <div style={{
          textAlign: 'center',
          padding: '0 20px'
        }}>
          <p style={{
            fontFamily: "'Bodoni Moda', serif",
            fontSize: '1.8rem',
            lineHeight: 1.4,
            color: '#e6c57e',
            fontWeight: 400,
            margin: 0,
            fontStyle: 'italic',
            textShadow: '0 10px 30px rgba(0,0,0,0.5)'
          }}>
            ""
          </p>
        </div>

      </div>

      {/* Shared Styles */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Bodoni+Moda:ital,opsz,wght@0,6..96,400;0,6..96,500;1,6..96,400&family=Montserrat:wght@300;400;500;600;700&display=swap');
        
        /* Reusable Glass Card Class */
        .glass-card {
          background: rgba(255, 255, 255, 0.03);
          backdrop-filter: blur(30px);
          -webkit-backdrop-filter: blur(30px);
          border: 1px solid rgba(255, 255, 255, 0.08);
          border-radius: 24px;
          margin-bottom: 24px;
          box-shadow: 0 20px 40px rgba(0,0,0,0.2);
          overflow: hidden;
        }

        /* Headers for Sections */
        .section-header {
          font-family: 'Bodoni Moda', serif;
          font-size: 1.5rem;
          color: #e6c57e;
          font-weight: 400;
          margin-bottom: 15px;
          letter-spacing: 0.02em;
        }

        /* Button Interaction */
        .ios-button:active {
          transform: scale(0.92);
          background: rgba(198,162,91,0.15) !important;
          border-color: #c6a25b !important;
        }

        html { scroll-behavior: smooth; }
      `}</style>
    </div>
  );
}